import { render } from "./PostCommentBox.vue?vue&type=template&id=42ab36ee"
import script from "./PostCommentBox.vue?vue&type=script&lang=js"
export * from "./PostCommentBox.vue?vue&type=script&lang=js"
script.render = render

export default script